import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Headings,
  Button,
  Paragraph,
  ExternalLinkIcon,
} from '@sentara-health/optimahealth_web';
import {
  ANALYTICS_MESSAGES,
  useAnalytics,
} from 'common';

//  Initialize useTranslation hook

interface CommonClaimsProps {
  staticUrlLink: string;
  claimTitle: string;
  claimMsg: string;
  analyticsFeatureName: string;
}

const CommonClaims: React.FC<CommonClaimsProps> = ({
  staticUrlLink,
  claimTitle,
  claimMsg,
  analyticsFeatureName,
}) => {
  const { t } = useTranslation();
  const { trackContentListing } = useAnalytics();
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return;
    trackContentListing(
      '1001',
      `${ANALYTICS_MESSAGES.SSO_INTERSTITIAL_PAGE_LOAD} - ${claimTitle}`,
      1
    );
    effectRan.current = true;
  }, [trackContentListing, claimTitle]);

  return (
    <>
      <div className="mb-4">
        <Headings
          level={1}
          text={claimTitle}
          variant="semiBold"
          dataTestId="pharmacyHeader"
        />
      </div>
      <div className="pharmacy_claims_wrapper mb-4">
        <Paragraph
          text={claimMsg}
          variant="regular"
          data-testid="pharmacyClaimsText"
        />
        <div className="d-flex align-items-center">
          <Button
            dataTestId={'continueNavigate'}
            onClick={() => {
              trackContentListing(
                '1004',
                `${ANALYTICS_MESSAGES.SSO_LAUNCH_SUCCESS} - ${claimTitle}`,
                4
              );
              window.open(staticUrlLink, '_blank');
            }}
            iconRight={<ExternalLinkIcon />}
            variant="link_btn"
            iconStroke="none"
          >
            {t('common.continue')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CommonClaims;
